import axios from "axios";

console.log("Ambiente:", process.env.VUE_APP_URL);

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

export default axiosInstance;
